// Messages for validation
window.validateMessages = {
    ru: {
        required: 'Не заполнено поле',
        minlength: 'Минимум %min% символов',
        email: 'Неправильный формат',
        fileformat: 'Недопустимый тип файла',
        filesize: 'Файл должен быть до %max% МБ',
        daterange: 'Дата начала больше даты окончания',
        emptyfield: 'Поле не заполнено'
    }
}[App.lang];

window.tooltips = {
    ru: {
        collapseText: 'Показать всё',
        collapseTextReplace: 'Свернуть',
    }
}[App.lang];
